module.exports = __webpack_public_path__ + "static/media/grid-noactive.1b4d6da2.svg";